import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import getSharingInfoResponse from 'owa-service/lib/factory/getSharingInfoResponse';
import { lazyGetSharingInformation as lazyGetSharingInformationService } from 'owa-sharing-data';

export default async function getSharingInformation(url: string): Promise<GetSharingInfoResponse> {
    let response: GetSharingInfoResponse;
    const {
        name: eventName,
        customData: customData,
    } = datapoints.GetSharingInformationFailure.datapoint;
    let errorType: string = null;
    try {
        const getSharingInformationService = await lazyGetSharingInformationService.import();
        response = await getSharingInformationService(url);
    } catch (error) {
        errorType = error.fetchErrorType;
        response = getSharingInfoResponse({
            ResultCode: AttachmentResultCode.GenericFailure,
        });
    }

    if (response.ResultCode !== AttachmentResultCode.Success) {
        logUsage(eventName, customData(errorType, response.ResultCode));
    }
    return response;
}
